/* eslint-disable react/display-name */

import { useState } from "react";

import Button from "app/components/shared/Button";
import Emojify from "app/components/shared/Emojify";
import Panel from "app/components/shared/Panel";

import permissions from "app/lib/permissions";
import FlashesStore from "app/stores/FlashesStore";

import AccessLevel from "./access-level";

const Row = ({ teamRegistry, onRemoveClick, onAccessLevelChange }) => {
  const [savingNewAccessLevel, setSavingNewAccessLevel] = useState(null);
  const [removing, setRemoving] = useState(null);

  const registry = teamRegistry.registry;

  const handleAccessLevelChange = (accessLevel) => {
    setSavingNewAccessLevel(accessLevel);

    onAccessLevelChange(teamRegistry, accessLevel, (error) => {
      setSavingNewAccessLevel(null);

      if (error) {
        FlashesStore.flash(FlashesStore.ERROR, error);
      }
    });
  };

  const handleRegistryRemove = (evt) => {
    if (confirm("Remove the registry from this team?")) {
      evt.preventDefault();

      performRegistryRemove(false);
    }
  };

  const performRegistryRemove = (force) => {
    setRemoving(true);

    onRemoveClick(teamRegistry, force, (error) => {
      setRemoving(false);

      if (error) {
        if (
          !force &&
          error.source &&
          error.source.type === "must_force_error"
        ) {
          if (
            confirm(
              error.source.errors[0].message +
                "\n\nAre you sure you want to remove this registry from this team?",
            )
          ) {
            performRegistryRemove(true);
          }
        } else {
          FlashesStore.flash(FlashesStore.ERROR, error);
        }
      }
    });
  };

  const Actions = () =>
    permissions(teamRegistry.permissions).collect(
      {
        always: true,
        render: (idx) => (
          <AccessLevel
            key={idx}
            teamRegistry={teamRegistry}
            onAccessLevelChange={handleAccessLevelChange}
            saving={savingNewAccessLevel}
          />
        ),
      },
      {
        allowed: "teamRegistryDelete",
        render: (idx) => (
          <Button
            key={idx}
            loading={removing ? "Removing…" : false}
            className="ml3"
            onClick={handleRegistryRemove}
          >
            Remove
          </Button>
        ),
      },
    );

  return (
    <Panel.Row>
      <div className="flex">
        <a
          className="truncate semi-bold black hover-lime hover-color-inherit-parent text-decoration-none"
          href={registry.url}
          title={registry.name}
        >
          <Emojify text={registry.name} />
        </a>
      </div>
      <Panel.RowActions className="ml2">
        <Actions />
      </Panel.RowActions>
    </Panel.Row>
  );
};

export default Row;
